module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid",
    attrs: {
      "id": "index"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("NEOJ is now read-only, move to new Sprout OJ!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-377f6c73"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Index.vue
// module id = 576
// module chunks = 0